// @flow

import { forEach, get, has, map, omit, pickBy } from "lodash";
import { type RaceProgram } from "@tvg/types/Race";

const createRaceDataForHeader = (race: RaceProgram): RaceProgram[] => {
  const keysRace = [
    "type.name",
    "numRunners",
    "distance",
    "surface.name",
    "surface.defaultCondition"
  ];

  const changesKeyMap = {
    distance: "distance",
    "surface.shortName": "course",
    "surface.defaultCondition": "condition"
  };

  const surfaceChanges = pickBy(get(race, "changes.surface"));
  const resArr = [];
  const getException = (item, value) => {
    if (item === "numRunners") {
      return `${value} Runners`;
    }
    if (value === "QuarterHorse") {
      return "Quarter Horse";
    }
    return value;
  };

  if (race) {
    forEach(keysRace, (item: string) => {
      const defRes = {
        item,
        changed: Object.keys(surfaceChanges).indexOf(changesKeyMap[item]) !== -1
      };

      if (has(race, item)) {
        const raceItem = get(race, item);
        if (raceItem) {
          resArr.push({
            ...defRes,
            value: getException(item, raceItem)
          });
        }
      }
    });
    return map(resArr, (e) => omit(e, "item"));
  }
  return [];
};

export const fixedOffset = (withVideo: boolean): number => {
  let fixedOffsetValue = 0;

  if (withVideo && typeof window !== "undefined") {
    fixedOffsetValue = (window.innerWidth * 9) / 16;
  }
  return fixedOffsetValue > 284 ? 332 : fixedOffsetValue + 48;
};

export default createRaceDataForHeader;
